import React from 'react';
import classNames from 'classnames';
import useInteractiveAttributes from '../../../hooks/use-interactive-handler';

const InteractiveBox = ({ selected = false, children, onClick }) => {
  const classes = classNames('ws-ui-color-selector__interactive-box', {
    'ws-ui-color-selector__interactive-box--selected': selected,
  });

  const interactiveAttributes = useInteractiveAttributes(onClick);

  return (
    // @ts-ignore TS(2322): Type '{ children: ReactNode; role?: string | undef... Remove this comment to see the full error message
    <div
      className={classes}
      {...(!selected && {
        onClick,
        ...interactiveAttributes,
      })}
    >
      {children}
    </div>
  );
};

export default InteractiveBox;
